export const HOME = "/";
export const GALLERY = "/gallery";
export const MUSIC = "/music";
export const EVENTS = "/events";
export const CONTACT = "/contact";